"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _util = require("../util");

var _Expando = require("../../Expando");

var _Icon = _interopRequireDefault(require("../../Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterList = function FilterList(_ref) {
  var title = _ref.title,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? [] : _ref$checked,
      _ref$counts = _ref.counts,
      counts = _ref$counts === void 0 ? {} : _ref$counts,
      name = _ref.name,
      toggleFilter = _ref.toggleFilter,
      className = _ref.className,
      defaultOpen = _ref.defaultOpen,
      _ref$minOptions = _ref.minOptions,
      minOptions = _ref$minOptions === void 0 ? 1 : _ref$minOptions;

  if (options.filter(function (opt) {
    return !(0, _util.isUselessValue)(opt);
  }).length < minOptions) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement(_Expando.RawExpando, {
      defaultOpen: defaultOpen
    }, function (_ref2) {
      var toggle = _ref2.toggle,
          open = _ref2.open;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('FilterList', className)
      }, /*#__PURE__*/_react.default.createElement("h5", {
        className: "toggle",
        onClick: toggle
      }, title, ' ', /*#__PURE__*/_react.default.createElement(_Icon.default, {
        icon: open ? 'chevron-up' : 'chevron-down',
        size: "small"
      })), open && /*#__PURE__*/_react.default.createElement("ul", null, options.sort(function (a, b) {
        return "".concat(a).localeCompare("".concat(b));
      }).map(function (option) {
        var disabled = counts[option] === 0;
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _util.isUselessValue)(option) && /*#__PURE__*/_react.default.createElement("li", {
          key: option
        }, /*#__PURE__*/_react.default.createElement("input", {
          type: "checkbox",
          onChange: function onChange() {
            toggleFilter(name, option);
          },
          checked: checked[name].includes(option)
        }), /*#__PURE__*/_react.default.createElement("span", {
          style: {
            cursor: 'pointer'
          },
          onClick: function onClick() {
            toggleFilter(name, option);
          },
          className: (0, _classnames.default)({
            disabled: disabled
          })
        }, option, " ", /*#__PURE__*/_react.default.createElement("small", null, "(", counts[option], ")"))));
      })));
    });
  }
};

var _default = FilterList;
exports.default = _default;